export default "__VITE_ASSET__C9Ohz0nf__"